import firebase from "../firebase";
import moment, { now } from "moment";
import Common from "../common/Common"
import { DbUser, DbUserCourseManagement, DbUserCourseManagementDetail } from "@/database/DbUser";
import { DbCourseManagementUsersExcelText, DbCourseManagement, DbCourseManagementDetails } from "@/database/DbCourseManagement";
import { DbHistoryManagement, DbHistoryManagementDetail } from "@/database/DbHistoryManagement";

import { AuthUtile } from "../auth/AuthUtile";

export class ResultUser {
    public id: string | null = null;
    public u: DbUser | null = null;
}

export class ResultDbCourseManagement {
    public id: string | null = null;
    public data: DbCourseManagement | null = null;
}

export class ResultDbUserCourseManagement {
    public id: string | null = null;
    public courseManagement: DbUserCourseManagement | null = null;
}

export class ResultDbCourseManagementDetails {
    public id: string | null = null;
    public courseManagementDetails: DbCourseManagementDetails | null = null;
}


export class DbUtile {
    private auth: firebase.auth.Auth;
    private db: firebase.firestore.Firestore;

    constructor(){
        this.db = firebase.firestore();
        this.auth = firebase.auth();
    }

    // ユーザーが登録済みかチェックする
    public userEmailExists(email: string): Promise<string> {
        console.log('userEmailExists', email);
        // firebase functions で getUserByEmail を実行
        return new Promise((resolve,reject) => {
            const func = firebase.functions().httpsCallable('getUserByEmail');
            func({email: email})
                .then((result) => {
                    const data = result.data;
                    console.log('data', data);
                    if (data.uid){
                        console.log('resolve');
                        resolve( data.uid );
                    } else {
                        console.log('reject');
                        reject();
                    }
                })
                .catch((e) => {
                    console.error('userEmailExists', e);
                    reject(e);
                });
        });
    }

    // ユーザーを DB に 追加する
    public addUser(courseManagementId: string, src: DbUser): Promise<ResultUser> {
        return new Promise((resolve, reject) => {
            // ユーザー有無確認
            this.userEmailExists(src.email)
                .then((uid) => {
                    console.log('userEmailExists', uid);
                    // 登録済みの場合 
                    // -- 登録済みユーザーを返す
                    return this.getUser(uid)
                        .then((data) => {
                            // 追加 course_managements -> [courseManagementId] -> users
                            src.uid = uid;
                            this.db
                                .collection('course_managements')
                                .doc(courseManagementId)
                                .collection("users")
                                .withConverter(DbUser.Converter)
                                .doc(data.id!)
                                .set(src)
                                .then((docRef) => {
                                    console.log("src.email", src.email);
                                    resolve({id: data.id!, u: src});
                                })
                                .catch((e) => {
                                    console.error(e);
                                });
                            
                        })
                        .catch((e) => {
                            // メール登録済みだが users に登録がなかった場合
                            // -- users にも登録
                            src.uid = uid;

                            return this.db
                                .collection("users")
                                .withConverter(DbUser.Converter)
                                .add(src)
                                .then((docRef) => {
                                    console.log("src.email", src.email);
                                    src.uid = docRef.id;
                                    // 追加 course_managements -> [courseManagementId] -> users
                                    this.db
                                        .collection('course_managements')
                                        .doc(courseManagementId)
                                        .collection("users")
                                        .withConverter(DbUser.Converter)
                                        .doc(docRef.id)
                                        .set(src)
                                        .then((docRef2) => {
                                            console.log("src.email", src.email);
                                            resolve({id: docRef.id, u: src});
                                        })
                                        .catch((e) => {
                                            console.error(e);
                                        });
                                })
                                .catch((e) => {
                                    reject(e);
                                });
                        });
                })
                .catch((e) => {
                    console.log('userEmailExists null', src.email);
                    // 未登録の場合 追加
                    // -- ユーザーを登録する
                    const password = Common.createRandomString(8);
                    this.auth
                        .createUserWithEmailAndPassword(src.email, password)
                        .then((userCredential) => {
                            console.log("userCredential", userCredential);
                            const user = userCredential.user;
                            if (user == null) {
                                reject(null);
                                return;
                            }
                            src.uid = user.uid;

                            // 2021.03.05 初回登録時のパスワード再設定メール送信はしない
                            /*
                            AuthUtile.sendPasswordResetEmail(this.auth, src.email, false)
                                .then(() =>{
                                    console.log('sendPasswordResetEmail');
                                });
                            */

                            // -- users にも登録
                            return this.db
                                .collection("users")
                                .withConverter(DbUser.Converter)
                                .add(src)
                                .then((docRef) => {
                                    console.log("src.email", src.email);
                                    // 追加 course_managements -> [courseManagementId] -> users
                                    this.db
                                        .collection('course_managements')
                                        .doc(courseManagementId)
                                        .collection("users")
                                        .withConverter(DbUser.Converter)
                                        .doc(docRef.id)
                                        .set(src)
                                        .then((docRef) => {
                                            console.log("src.email", src.email);
                                        })
                                        .catch((e) => {
                                            console.error(e);
                                        });                                    
                                    resolve({id: docRef.id, u: src});
                                })
                                .catch((e) => {
                                    reject(e);
                                });
                        })
                        .catch((e) => {
                            console.error(e);
                            reject(e);
                        });
                });
        });
    }
    
    // ユーザー一覧を取得
    // courseManagementId: 講習ID
    public getUsersUserCourseManagement(courseManagementId: string): Promise<ResultUser[]> {
        return new Promise((resolve,reject) => {
            this.db
            .collection('course_managements')
            .doc(courseManagementId)
            .collection("users")
            .withConverter(DbUser.Converter)
            .get()
            .then((snapshot) => {
                const data: ResultUser[] = [];
                snapshot.forEach((doc) => {
                    data.push({id: doc.id, u: doc.data()});
                });
                resolve(data);
            })
            .catch((error) => {
                // console.error("Error adding document: ", error);
                reject(error);
            });
        });
    }

    // ユーザー取得
    public getUser(uid: string): Promise<ResultUser> {
        return new Promise((resolve,reject) => {
            console.log("getUser");
            // users 一覧から uid が一致するデータを取得する
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .where("uid", "==", uid)
                .get()
                .then((snapshot) => {
                    console.log("snapshot", snapshot.docs);
                    if (snapshot.docs.length == 0) {
                        reject(new Error("snapshot.empty"));
                        return;
                    }
                    let id: string | null = null;
                    let user: DbUser | null = null;
                    snapshot.docs.forEach((doc) => {
                        console.log(" doc", doc);
                        id = doc.id;
                        user = doc.data();
                    });
                    console.log("user", user);
                    if (user != null){
                        resolve({id: id!, u: user!});
                    }
                    else {
                        reject(new Error("user is null"));
                    }
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // 講座 申込別の ユーザー取得 
    // course_managements -> [courseManagementId] -> users
    public getCourseManagementUser(courseManagementId: string, uid: string): Promise<ResultUser> {
        return new Promise((resolve,reject) => {
            console.log("getCourseManagementUser");
            // users 一覧から uid が一致するデータを取得する
            this.db
                .collection('course_managements')
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbUser.Converter)
                .where("uid", "==", uid)
                .get()
                .then((snapshot) => {
                    console.log("snapshot", snapshot.docs);
                    if (snapshot.docs.length == 0) {
                        reject(new Error("snapshot.empty"));
                        return;
                    }
                    let id: string | null = null;
                    let user: DbUser | null = null;
                    snapshot.docs.forEach((doc) => {
                        console.log(" doc", doc);
                        id = doc.id;
                        user = doc.data();
                    });
                    console.log("user", user);
                    if (user != null){
                        resolve({id: id!, u: user!});
                    }
                    else {
                        reject(new Error("user is null"));
                    }
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // ユーザー削除
    public deleteUserCourseManagement(id: string, courseManagementId: string): Promise<{}[]> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(id)
                .collection("course_managements")
                .withConverter(DbUserCourseManagement.Converter)
                .doc(courseManagementId)
                .delete()              
                .then((snapshot1) => {
                    console.log("snapshot1", snapshot1);
                    // 一覧を取得
                    this.getUsersUserCourseManagement(courseManagementId)
                    .then((rows) => {
                        resolve(rows);
                    });
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // ユーザー削除
    public deleteUser(courseManagementId: string, id: string): Promise<void> {
        return new Promise((resolve,reject) => {
            // course_managements　-> [courseManagementId] -> users -> [id] 削除
            this.db
                .collection('course_managements')
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(id)
                .delete()
                .then((snapshot) => {
                    console.log("snapshot", snapshot);
                })
                .catch((error) => {
                    reject(error);
                });

            
            // users -> [id] 削除
            this.db
                .collection("users")
                .doc(id)
                .get()
                .then((docRef) => {
                    // コレクションの削除 も　不要？
                    // docRef.ref.collection('course_managements')
                    //     .doc(courseManagementId)
                    //     .delete();
                    // users ドキュメントは 削除してはいけない
                    // docRef.ref.delete();
                    resolve();
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // ユーザー更新
    public updateUser(id: string, src: DbUser): Promise<DbUser> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(id)
                .set(src)
                .then(() => {
                    resolve(src);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    // ユーザーに講習を追加する
    public addUserCourseManagement(uid: string, src: DbUserCourseManagement): Promise<DbUserCourseManagement> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(uid)
                .collection('course_managements')
                .withConverter(DbUserCourseManagement.Converter)
                .doc(src.id)
                .get()
                .then((docRef) => {
                    if (docRef.exists == false) {
                        // 未登録の場合 追加する
                        docRef.ref.set(src);
                    }
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    // 講習一覧を取得
    public getCourseManagements(courseId: string, courseName: string): Promise<ResultDbCourseManagement[]> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .orderBy("courseId")
                .get()
                .then((snapshot) => {
                    let data: ResultDbCourseManagement[] = [];         
                    snapshot.forEach((doc) => {
                        data.push({id: doc.id, data: doc.data()});
                    });
                    if (courseId.length != 0 && data.length > 0) {
                        data = data.filter(d => { 
                            // 講習IDで絞り込み
                            const n = d.data!.courseId.indexOf(courseId);
                            return (n != -1);
                        })
                    }
                    if (courseName.length != 0 && data.length > 0) {
                        data = data.filter(d => { 
                            // 講習名で絞り込み
                            const n = d.data!.name.indexOf(courseName);
                            return (n != -1);
                        });
                    }
                    resolve(data);
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // 講習 情報を保存する
    public addCourseManagement(id: string | null, src: DbCourseManagement): Promise<DbCourseManagement> {
        return new Promise((resolve,reject) => {
            console.log("addCourseManagement", id, src);
            if (id == null){
                // 新規作成
                this.db
                    .collection("course_managements")
                    .withConverter(DbCourseManagement.Converter)
                    .add(src)
                    .then((doc) => {
                        console.log('doc', doc);
                        src.uid = doc.id;
                        resolve(src);
                    })
                    .catch((error) => {
                        // console.error("Error adding document: ", error);
                        reject(error);
                    });
            } else {
                // 更新
                this.db
                    .collection("course_managements")
                    .withConverter(DbCourseManagement.Converter)
                    .doc(id)
                    .set(src)
                    .then((doc) => {
                        console.log('doc', doc);
                        resolve(src);
                    })
                    .catch((error) => {
                        // console.error("Error adding document: ", error);
                        reject(error);
                    });      
            }
            
        });
    }

    // 講習を削除する
    public deleteCourseManagement(id: string): Promise<ResultDbCourseManagement[]>{
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .doc(id)
                .delete()
                .then((snapshot1) => {
                    console.log("snapshot1", snapshot1);
                    this.getCourseManagements("", "")
                    .then((rows) => {
                        console.log("rows", rows);
                        resolve(rows);
                    })
                    .catch((e) => {
                        reject(e);
                    });
                })
                .catch((error) => {
                    reject(error);
                });  
        });
    }

    // 講習 を取得
    public getCourseManagement(id: string): Promise<DbCourseManagement> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)
                .get()
                .then((doc) => {
                    resolve(doc.data());
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

   // 講習詳細一覧 を取得
   public getCourseManagementDetails(id: string): Promise<ResultDbCourseManagementDetails[]> {
    console.log("getCourseManagementDetails", id);
    return new Promise((resolve,reject) => {
        this.db
            .collection("course_managements")
            .withConverter(DbCourseManagement.Converter)
            .doc(id)
            .collection("course_management_details")
            .withConverter(DbCourseManagementDetails.Converter)
            .get()
            .then((snapshot) => {       
                const data: ResultDbCourseManagementDetails[] = [];
                snapshot.forEach((doc) => {
                    data.push({id: doc.id, courseManagementDetails: doc.data()});
                });
                resolve(data);
            })
            .catch((error) => {
                // console.error("Error adding document: ", error);
                reject(error);
            });
        });
    }

    // 講習詳細 登録
    public addCourseManagementDetails(id: string, courseManagementDetails: DbCourseManagementDetails): Promise<{}> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)                
                .collection("course_management_details")
                .withConverter(DbCourseManagementDetails.Converter)
                .add(courseManagementDetails)           
                .then((doc) => {
                    const data = {id: doc.id, data: courseManagementDetails};
                    console.log("data", data);
                    resolve(data);
                })
                .catch((error) => {
                    // console.error("Error adding document: ", error);
                    reject(error);
                });
        });
    }

    // 講習詳細 更新
    public updateCourseManagementDetails(id: string, did: string, details: DbCourseManagementDetails): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)                
                .collection("course_management_details")
                .withConverter(DbCourseManagementDetails.Converter)
                .doc(did)
                .set(details)
                .then(() => {
                    resolve();
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    // 講習詳細 削除
    public deleteCourseManagementDetail(id: string, did: string): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)                
                .collection("course_management_details")
                .withConverter(DbCourseManagementDetails.Converter)
                .doc(did)
                .delete()
                .then(() => {
                    resolve();
                })
                .catch((e) => {
                    console.log('e', e);
                    reject(e);
                });
        });
    }

    // 講習詳細 全て削除
    public deleteCourseManagementDetailAll(id: string): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)                
                .collection("course_management_details")
                .get()
                .then((snapshot) => {
                    const batch = this.db.batch();
                    snapshot.docs.forEach(doc => {
                        batch.delete(doc.ref);
                    });
                    batch.commit().then(() => {
                        resolve();
                    });
                })
                .catch((e) => {
                    console.log('e', e);
                    reject(e);
                });
        });
    }

    // ユーザー指定 の 受講講習一覧
    public getUserCourseManagements(id: string): Promise<ResultDbUserCourseManagement[]> {
        return new Promise((resolve,reject) => {
            console.log("getUserCourseManagements", id)
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(id)
                .collection("course_managements")
                .withConverter(DbUserCourseManagement.Converter)
                .get()
                .then((snapshot) => {
                    console.log('snapshot', snapshot);
                    const result: ResultDbUserCourseManagement[] = [];
                    snapshot.docs.forEach((doc) => {
                        result.push({id: doc.id, courseManagement: doc.data()});
                    });
                    resolve(result);
                })
                .catch((e) => {
                    console.error(e);
                    reject(e);
                });
        });
    }

    // 講習詳細 取得
    public getCourseManagementDetail(id: string, courseManagementDetailsId: string): Promise<DbCourseManagementDetails> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(id)                
                .collection("course_management_details")
                .withConverter(DbCourseManagementDetails.Converter)
                .doc(courseManagementDetailsId)
                .get()
                .then((doc) => {
                    resolve(doc.data());
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // ユーザー講習詳細 受講ステータスを登録,更新する
    public updateUserCourseManagementDetail(uid: string, courseManagementId: string, courseManagementDetailsId: string, status: string): Promise<DbUserCourseManagementDetail>{
        console.log("updateUserCourseManagementDetail", status);
        return new Promise((resolve,reject) => {
            const data = new DbUserCourseManagementDetail();
            data.id = courseManagementDetailsId;
            data.status = status;
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(uid)
                .collection('course_managements')
                .withConverter(DbUserCourseManagement.Converter)
                .doc(courseManagementId)
                .collection('course_management_details')
                .withConverter(DbUserCourseManagementDetail.Converter)
                .doc(courseManagementDetailsId)
                .get()
                .then((docRef) => {
                    console.log("docRef", docRef);
                    if (docRef.exists == false) {
                        // 新規作成
                        docRef.ref.set(data);
                    }
                    else {
                        if (data.status == DbHistoryManagement.STATUS.During) {
                            if (docRef.data()?.status == null || docRef.data()?.status == DbHistoryManagement.STATUS.NotAttended) {
                                // 受講開始日時 を 設定する
                                docRef.ref.update({status:data.status});
                            }
                        }
                        else if (data.status == DbHistoryManagement.STATUS.Done) {
                            // 更新 受講完了日時
                            docRef.ref.update({status:data.status});
                        }
                    }
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    // ユーザー講習詳細 受講ステータスを取得
    public getUserCourseManagementDetail(uid: string, courseManagementId: string, courseManagementDetailsId: string): Promise<DbUserCourseManagementDetail>{
        return new Promise((resolve,reject) => {
            const src = new DbUserCourseManagementDetail();
            src.id = courseManagementDetailsId;
            src.status = status;
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(uid)
                .collection('course_managements')
                .withConverter(DbUserCourseManagement.Converter)
                .doc(courseManagementId)
                .collection('course_management_details')
                .withConverter(DbUserCourseManagementDetail.Converter)
                .doc(courseManagementDetailsId)
                .get()
                .then((doc) => {
                    const ucmd = doc.data()!;
                    resolve(ucmd);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    // 受講履歴を登録
    // history_management -> [courseManagementId] -> users -> [userId]
    public addHistoryManagement(userId: string, user: DbUser, courseManagementId: string, src: DbUserCourseManagement): Promise<DbHistoryManagement>{
        console.log('addHistoryManagement');
        return new Promise((resolve,reject) => {
            const data = new DbHistoryManagement();
            data.courseManagementId = courseManagementId;
            data.applicationNumber = user.applicationNumber;
            data.name = user.name;
            data.nameFurigana = user.nameFurigana;
            data.email = user.email;
            data.status = src.status;
            data.from = null;
            data.to = null;
            data.uid = user.uid;
            data.id = userId;
            data.lecturesSubcommittees = user.lecturesSubcommittees;
            if (data.status == DbHistoryManagement.STATUS.During) {
                // 受講開始日時
                data.from = new Date();
            }
            if (data.status == DbHistoryManagement.STATUS.Done) {
                // 受講完了日時
                data.to = new Date(); 
            }            
            this.db
                .collection("history_management")
                .withConverter(DbHistoryManagement.Converter)
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbHistoryManagement.Converter)
                .doc(userId)
                .get()
                .then((docRef) => {
                    if (docRef.exists == false) {
                        // 新規作成
                        docRef.ref.set(data);
                    }
                    else {                        
                        if (data.status == DbHistoryManagement.STATUS.During) {
                            if (docRef.data()?.from == null){
                                // 受講開始日時 を 設定する
                                docRef.ref.update({status:data.status, from: data.from});
                            }
                        }
                        else if (data.status == DbHistoryManagement.STATUS.Done) {
                            // 更新 受講完了日時
                            docRef.ref
                                .get()
                                .then((docRef2) => {
                                    // to 受講完了 未設定の場合だけ 更新
                                    if (docRef2.data()?.to == null){
                                        docRef.ref.update({status:data.status, to: data.to});
                                    }
                                });
                        }
                    }
                    resolve(data)
                })
                .catch((e) => {
                    // console.error('error', e);
                    // 新規作成
                    this.db
                        .collection("history_management")
                        .doc(courseManagementId)
                        .collection("users")
                        .withConverter(DbHistoryManagement.Converter)
                        .doc(userId)
                        .set(data)
                        .then(() => {
                            resolve(data)
                        })
                        .catch((e) => {
                            console.error(e);
                        });
                });


        });
    }

    // 履歴一覧を取得
    public getHistoryManagement(courseManagementId: string, name: string, status: string): Promise<DbHistoryManagement[]> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbHistoryManagement.Converter)
                .get()
                .then((snapshot) => {
                    let result: DbHistoryManagement[] = [];
                    snapshot.docs.forEach((doc) => {
                        result.push(doc.data());
                    });
                    // 名前 フィルター
                    if (name.length != 0) {
                        result = result.filter(d => { 
                            // 氏名,ふりがな どちらも検索する
                            const n = d.name.indexOf(name);
                            const f = d.nameFurigana.indexOf(name);
                            return ((n != -1) || (f != -1));
                        });
                    }
                    // ステータス フィルター
                    if (status.length != 0){
                        result = result.filter(d => { 
                            return (d.status == status);
                        });
                    }
                    resolve(result)
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // 受講履歴 詳細を登録
    // history_management -> [courseManagementId] -> users -> [userId]
    public addDbHistoryManagementDetails(userId: string, user: DbUser, courseManagementId: string, src: DbUserCourseManagement, courseManagementDetailsId: string, courseManagementDetails: DbCourseManagementDetails): Promise<DbHistoryManagement>{
        return new Promise((resolve,reject) => {
            console.log("user", user);
            console.log("courseManagementDetails", courseManagementDetails);
            const data = new DbHistoryManagementDetail();
            data.courseManagementId = courseManagementId;
            data.applicationNumber = user.applicationNumber;
            data.name = user.name;
            data.nameFurigana = user.nameFurigana;
            data.email = user.email;
            data.ainderGarten = user.ainderGarten;
            data.prefectures = user.prefectures;
            data.municipality = user.municipality;
            data.courseManagementDetailsId = courseManagementDetailsId;    
            data.subcommitteeNumber = courseManagementDetails.subcommitteeNumber;
            data.chapterID = courseManagementDetails.chapterID;
            data.lectureName = courseManagementDetails.lectureName;
            data.classification = courseManagementDetails.classification;
            data.description = courseManagementDetails.description;
            data.videoID = courseManagementDetails.videoID;
            data.playbackSpeedChange = courseManagementDetails.playbackSpeedChange;
            data.meetingURL = courseManagementDetails.meetingURL;
            data.status = src.status;
            data.from = null;
            data.to = null;
            data.uid = user.uid;
            data.id = userId;
            data.lecturesSubcommittees = user.lecturesSubcommittees;
            if (data.status == DbHistoryManagementDetail.STATUS.During) {
                // 受講開始日時
                data.from = new Date();
            }
            if (data.status == DbHistoryManagementDetail.STATUS.Done) {
                // 受講完了日時               
                data.to = new Date();
            }

            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .doc(userId)
                .withConverter(DbHistoryManagement.Converter)
                .collection("history_management_details")
                .withConverter(DbHistoryManagementDetail.Converter)
                .doc(courseManagementDetailsId)
                .get()
                .then((docRef) => {
                    if (docRef.exists == false) {
                        // 新規作成
                        docRef.ref.set(data);
                        resolve();
                    }
                    else {
                        docRef.ref.update({lectureName:data.lectureName});                        
                        if (data.status == DbHistoryManagementDetail.STATUS.During) {
                            if (docRef.data()?.from == null){
                                // 受講開始日時を設定する
                                docRef.ref.update({status:data.status, from: data.from});
                            }
                            resolve();
                        }
                        else if (data.status == DbHistoryManagementDetail.STATUS.Done) {
                            // 更新 受講完了日時
                            docRef.ref
                                .get()
                                .then((docRef2) => {
                                    // to 受講完了 未設定の場合だけ 更新
                                    if (docRef2.data()?.to == null){
                                        if (data.classification == "ライブ配信") {
                                            // ライブ配信ときは 両方の日付を埋める                                
                                            docRef.ref.update({status:data.status, from: data.to, to: data.to});
                                        }　else {
                                            docRef.ref.update({status:data.status, to: data.to});
                                        }
                                    }
                                    resolve();
                                });
                        }
                    }
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // 履歴一覧を取得
    public getHistoryManagementDetails(courseManagementId: string, name: string, status: string): Promise<DbHistoryManagementDetail[]> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbHistoryManagement.Converter)
                .get()
                .then((snapshot) =>{
                    console.log('getHistoryManagementDetails', snapshot.docs);
                    let result: DbHistoryManagementDetail[] = [];
                    const promises: Promise<DbHistoryManagementDetail[]>[] = [];
                    snapshot.docs.forEach(d => {
                        const userId = d.id;
                        console.log('userId', userId);
                        promises.push(
                            this.getUserHistoryManagementDetails(userId, courseManagementId, name, status)
                        );                     
                    });
                    Promise.all(promises)
                        .then((ress) => {
                            ress.forEach(res => {
                                result = result.concat(res);
                            });
                            console.log('result2', result);
                            resolve(result);                        
                        });
                });
        });
    }

    // 履歴詳細一覧
    public getUserHistoryManagementDetails(userId: string,courseManagementId: string, name: string, status: string): Promise<DbHistoryManagementDetail[]> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .doc(userId)
                .withConverter(DbHistoryManagement.Converter)
                .collection("history_management_details")
                .withConverter(DbHistoryManagementDetail.Converter)
                .get()
                .then((snapshot) => {
                    console.log('history_management_details', snapshot.docs);
                    let res: DbHistoryManagementDetail[] = [];
                    snapshot.docs.forEach((doc) => {
                        res.push(doc.data());
                    });
                    // 名前 フィルター
                    if (name.length != 0) {
                        res = res.filter(d => { 
                            // 氏名,ふりがな どちらも検索する
                            const n = d.name.indexOf(name);
                            const f = d.nameFurigana.indexOf(name);
                            return ((n != -1) || (f != -1));
                        });
                    }
                    // ステータス フィルター
                    if (status.length != 0){
                        res = res.filter(d => { 
                            return (d.status == status);
                        });
                    }
                    resolve(res);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // 各DBの受講 status を更新する
    public courseManagementStatusUpdate(courseManagementId: string, detailRows: DbHistoryManagementDetail[], detailCheckboxRows: any[]): Promise<void> {
        return new Promise((resolve,reject) => {
            let i = 0;
            detailRows.forEach((detail) => {
                const detailCheckbox = detailCheckboxRows[i];
                const promiseArray = [];
                // DbHistoryManagement
                // DbHistoryManagementDetail
                promiseArray.push( this.updateStatusHistoryManagementDetail(courseManagementId, detail) );
                // DbUserCourseManagement
                // DbUserCourseManagementDetail
                promiseArray.push( this.updateStatusUserCourseManagementDetail(courseManagementId, detail) );
                Promise.all(promiseArray).then(() => {
                    resolve();
                });
                i++;
            });
            resolve();
        });
    }

    public updateStatusHistoryManagementDetail(courseManagementId: string, historyManagementDetail: DbHistoryManagementDetail): Promise<void> {
        return new Promise((resolve,reject) => {
            const userId = historyManagementDetail.id;
            const courseManagementDetailsId = historyManagementDetail.courseManagementDetailsId;
            const status = historyManagementDetail.status;
            let from = null;
            let to = null;
            if (status == DbHistoryManagementDetail.STATUS.Done){
                from = new Date();
                to = new Date();
            }
            else if (status == DbHistoryManagementDetail.STATUS.NotAttended){
                // 何もしない
            }

            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .doc(userId)
                .withConverter(DbHistoryManagement.Converter)
                .collection("history_management_details")
                .doc(courseManagementDetailsId)
                .update({status: status, from: from, to: to})
                .then(() => {
                    // 履歴概要 の ステータス更新
                    this.updateDoneHistoryManagement(userId, courseManagementId, false)
                        .then(() => {
                            resolve();
                        });
                });            
        });
    }

    public updateStatusUserCourseManagementDetail(courseManagementId: string, historyManagementDetail: DbHistoryManagementDetail): Promise<void> {
        return new Promise((resolve,reject) => {
            const userId = historyManagementDetail.id;
            const courseManagementDetailsId = historyManagementDetail.courseManagementDetailsId;
            const status = historyManagementDetail.status;
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(userId)
                .collection('course_managements')
                .withConverter(DbUserCourseManagement.Converter)
                .doc(courseManagementId)
                .collection('course_management_details')
                .withConverter(DbUserCourseManagementDetail.Converter)
                .doc(courseManagementDetailsId)
                .update({status: status})
                .then(() => {
                    resolve();
                });
        });
    }
    
    // ユーザの履歴概要を 完了にする
    public updateStatusUserCourseManagement(userId: string, courseManagementId: string, status: string): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("users")
                .withConverter(DbUser.Converter)
                .doc(userId)
                .collection('course_managements')
                .withConverter(DbUserCourseManagement.Converter)
                .doc(courseManagementId)
                .get()
                .then((docRef) => {
                    if (status == DbUserCourseManagement.STATUS.Done) {
                        // 完了
                        docRef.ref.update({status: status, to: new Date()});
                    }
                    else if (status == DbUserCourseManagement.STATUS.During) {
                        // 受講中
                        docRef.ref.update({status: status, from: new Date()});
                    }
                    else if (status == DbUserCourseManagement.STATUS.NotAttended) {
                        // 未受講 
                        docRef.ref.update({status: status, from: null, to: null});
                    }
                    resolve();
                });
        });
    }

    // EXCELのコピペデータを保存する
    public addCourseManagementUsersExcelText(usersExcelText: DbCourseManagementUsersExcelText): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbUserCourseManagement.Converter)
                .doc(usersExcelText.courseId)
                .collection("course_management_users_excel_text")
                .withConverter(DbCourseManagementUsersExcelText.Converter)
                .doc('users_excel_text')
                .set(usersExcelText)
                .then((docRef) => {
                    resolve();
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // EXCELのコピペデータを取得する
    public getCourseManagementUsersExcelText(courseId: string): Promise<DbCourseManagementUsersExcelText> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagementUsersExcelText.Converter)
                .doc(courseId)
                .collection("course_management_users_excel_text")
                .withConverter(DbCourseManagementUsersExcelText.Converter)
                .doc('users_excel_text')
                .get()
                .then((docRef) => {
                    resolve(docRef.data());
                })
                .catch((e) => {
                    reject(e);
                });
        });
    }

    // ユーザーに関連した　履歴を全て削除
    public deleteUserHistory(userId: string, courseManagementId: string): Promise<void> {
        return new Promise((resolve,reject) => {
            //history_management 削除
            console.log('delete history_management', userId);
            this.db
                .collection("history_management")
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbHistoryManagement.Converter)
                .doc(userId)
                .delete()
                .then(() => {
                    console.log("deleteUserHistory");
                });
            // history_management_details 削除
            console.log('delete history_management_details');
            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .doc(userId)
                .withConverter(DbHistoryManagement.Converter)
                .collection("history_management_details")                
                .withConverter(DbHistoryManagementDetail.Converter)
                .get()
                .then((snapshot) => {
                    console.log('snapshot', snapshot);
                    snapshot.docs.forEach((doc) => {
                        doc.ref.delete();
                    });
                })
                .catch((e) => {
                    console.error(e);
                });            
            resolve();
        });
    }

    // 受講者の履歴詳細を削除
    public deleteUserHistoryDetail(userId: string, courseManagementId: string, courseManagementDetailsId: string): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .doc(userId)
                .withConverter(DbHistoryManagement.Converter)
                .collection("history_management_details")
                .doc(courseManagementDetailsId)                
                .delete()
                .then(() => {
                    resolve();
                })
                .catch((e) => {
                    console.error(e);
                    reject();
                });
        });
    }

    // 履歴詳細ステータスを確認し、履歴概要ステータスを更新
    public updateUserHistoryStatus(courseManagementId: string): Promise<void> {
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")                
                .doc(courseManagementId)
                .collection("users")
                .get()
                .then((users) => {
                    if (users.size == 0) {
                        resolve();
                    }

                    users.docs.forEach((user) => {
                        let allCount = 0;
                        let notAttendedCount = 0;
                        let duringCount = 0;
                        let doneCount = 0;

                        const userId = user.id;
                        const beforeStatus = user.data().status;

                        user.ref.collection("history_management_details").get()
                        .then((snapshot) => {
                            console.log('snapshot', snapshot);
                            snapshot.docs.forEach((doc) => {
                                allCount = allCount + 1;
                                const status: string = doc.get("status");
                                if (status == DbHistoryManagement.STATUS.NotAttended) {
                                    notAttendedCount = notAttendedCount + 1;
                                }
                                else if (status == DbHistoryManagement.STATUS.During) {
                                    duringCount = duringCount + 1;
                                }
                                else if (status == DbHistoryManagement.STATUS.Done) {
                                    doneCount = doneCount + 1;
                                }
                            });

                            if (notAttendedCount == allCount) {
                                this.db
                                    .collection("history_management")
                                    .doc(courseManagementId)
                                    .collection("users")
                                    .doc(userId)
                                    .withConverter(DbHistoryManagement.Converter)
                                    .update({
                                        status: DbHistoryManagement.STATUS.NotAttended,
                                        to: null
                                    })
                                    .then(() => {
                                        this.db
                                            .collection("users")
                                            .doc(userId)
                                            .collection("course_managements")
                                            .doc(courseManagementId)
                                            .update({
                                                status: DbHistoryManagement.STATUS.NotAttended,
                                                to: null
                                            })
                                            .then(() => {
                                                resolve();
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        resolve();
                                    })
                                    .catch((e) => {
                                        reject();
                                    });
                            }
                            else if (doneCount == allCount) {
                                if (beforeStatus == DbHistoryManagement.STATUS.Done) {
                                    resolve();
                                    return;
                                }

                                this.db
                                    .collection("history_management")
                                    .doc(courseManagementId)
                                    .collection("users")
                                    .doc(userId)
                                    .withConverter(DbHistoryManagement.Converter)
                                    .update({
                                        status: DbHistoryManagement.STATUS.Done,
                                        to: new Date()
                                    })
                                    .then(() => {
                                        this.db
                                            .collection("users")
                                            .doc(userId)
                                            .collection("course_managements")
                                            .doc(courseManagementId)
                                            .update({
                                                status: DbHistoryManagement.STATUS.Done,
                                                to: new Date()
                                            })
                                            .then(() => {
                                                resolve();
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        resolve();
                                    })
                                    .catch((e) => {
                                        reject();
                                    });
                            }
                            else {
                                this.db
                                    .collection("history_management")
                                    .doc(courseManagementId)
                                    .collection("users")
                                    .doc(userId)
                                    .withConverter(DbHistoryManagement.Converter)
                                    .update({
                                        status: DbHistoryManagement.STATUS.During,
                                        to: null
                                    })
                                    .then(() => {
                                        this.db
                                            .collection("users")
                                            .doc(userId)
                                            .collection("course_managements")
                                            .doc(courseManagementId)
                                            .update({
                                                status: DbHistoryManagement.STATUS.During,
                                                to: null
                                            })
                                            .then(() => {
                                                resolve();
                                            })
                                            .catch(() => {
                                                reject();
                                            });
                                        resolve();
                                    })
                                    .catch((e) => {
                                        reject();
                                    });
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            reject();
                        });
                    });
                })
                .catch((e) => {
                    reject();
                });           
        });
    }

    // 受講分 の 履歴詳細を追加する
    // DbUser に 分科会 設定がある場合 分科会一致するものだけ
    public addHistoryManagementDetails(userId: string, u: DbUser, ucm: DbUserCourseManagement, courseManagementId: string): Promise<void>{
        console.log("addHistoryManagementDetails", u);
        return new Promise((resolve,reject) => {
            this.db
                .collection("course_managements")
                .withConverter(DbCourseManagement.Converter)
                .doc(courseManagementId)                
                .collection("course_management_details")
                .withConverter(DbCourseManagementDetails.Converter)
                .get()
                .then((snapshot) => {
                    console.log('snapshot', snapshot);
                    // applicationLecturesSubcommittees
                    snapshot.docs.forEach((doc) => {
                        const courseManagementDetailsId = doc.id;
                        const courseManagementDetail = doc.data();
                        if (u.applicationLecturesSubcommittees.length == 0){
                            // 分科会 設定なし
                            this.addDbHistoryManagementDetails(userId, u, courseManagementId!, ucm, courseManagementDetailsId, courseManagementDetail);
                        }
                        else{
                            // 分科会 設定あり
                            u.applicationLecturesSubcommittees.forEach((a) => {
                                // 分科会 番号が一致した場合だけ 履歴詳細 登録
                                if(a == courseManagementDetail.subcommitteeNumber){
                                    this.addDbHistoryManagementDetails(userId, u, courseManagementId!, ucm, courseManagementDetailsId, courseManagementDetail);
                                }
                            });
                        }
                    });
                    resolve();
                });
        });
    }

    // 履歴概要の完了
    public updateDoneHistoryManagement(userId: string, courseManagementId: string, isLive: boolean): Promise<void>{
        console.log('updateDoneHistoryManagement');
        return new Promise((resolve,reject) => {
            this.db
                .collection("history_management")
                .doc(courseManagementId)
                .collection("users")
                .withConverter(DbHistoryManagement.Converter)
                .doc(userId)
                .collection("history_management_details")                
                .withConverter(DbHistoryManagementDetail.Converter)                
                .get()
                .then((snapshot) => {
                    // ステータスを確認する
                    let doneCnt = 0;
                    snapshot.docs.forEach((doc) => {
                        const data = doc.data();
                        // console.log("doc", data);
                        if ( data.status == DbHistoryManagementDetail.STATUS.Done ){
                            doneCnt++;
                        }
                    });
                    console.log("doneCnt", doneCnt);
                    console.log("snapshot.docs.length", snapshot.docs.length);
                    // console.log("courseManagementId", courseManagementId);
                    // console.log("userId", userId);
                    this.db
                        .collection("history_management")
                        .doc(courseManagementId)
                        .collection("users")
                        .withConverter(DbHistoryManagement.Converter)
                        .doc(userId)
                        .get()
                        .then((docRef) => {
                            let status = DbHistoryManagement.STATUS.NotAttended;
                            if (snapshot.docs.length == doneCnt) {
                                // 完了日時設定を確認 未設定の場合だけ更新
                                if (docRef.data()!.to == null){
                                    // 履歴概要 を 完了 にする
                                    if (isLive){
                                        // 初回 ライブ配信 完了
                                        docRef.ref.update({status: DbHistoryManagement.STATUS.Done, from: new Date(), to: new Date()});
                                    }
                                    else {
                                        // オンデマンド
                                        docRef.ref.update({status: DbHistoryManagement.STATUS.Done, to: new Date()});
                                    }
                                }
                                status = DbHistoryManagement.STATUS.Done;
                            }
                            else {
                                if (doneCnt == 0){
                                    // 履歴概要 を 未受講 に戻す
                                    docRef.ref.update({status: DbHistoryManagement.STATUS.NotAttended, from: null, to: null});
                                    status = DbHistoryManagement.STATUS.NotAttended;
                                }
                                else {
                                    // 履歴概要 を 受講中 に戻す
                                    const doc = docRef.data();
                                    if (doc?.from == null){
                                        const data = {status: DbHistoryManagement.STATUS.During, from: new Date(), to: null};
                                        docRef.ref.update(data);
                                    }
                                    else {
                                        const data = {status: DbHistoryManagement.STATUS.During, to: null};
                                        docRef.ref.update(data);
                                    }
                                    status = DbHistoryManagement.STATUS.During;
                                }
                            }

                            // ユーザの履歴概要も完了にする
                            // /users/NhtGpBqJzbIe2j905GgR/course_managements/0xg1b2PKAuTn2tj0eN9W/course_management_details 
                            this.updateStatusUserCourseManagement(userId, courseManagementId, status);
                        })
                        .catch(e => {
                            console.error(e);
                        });
                        resolve();                 
                })
                .catch(e => {
                    console.error(e);
                });
        });
    }
}